import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, fromEvent, interval, map, merge, Observable, of, switchMap } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FrConnectionMonitorService  {
  private heartbeatInterval = 5000; 
  private heartbeatUrl = environment.apiUrl + '/healthcheck/internetcheck';

  private httpClient: HttpClient;

  constructor(
    handler: HttpBackend
  ) {
    this.httpClient = new HttpClient(handler); // this allows to bypass http interceptors (like msal interceptor)
  }

  public monitor(): Observable<FrConnectionState> {
    return merge(
      of(new FrConnectionState(navigator.onLine)),
      fromEvent(window, 'online').pipe(map(() => new FrConnectionState(true))),
      fromEvent(window, 'offline').pipe(map(() => new FrConnectionState(false))),
      interval(this.heartbeatInterval).pipe(
      switchMap(() => {
        return this.httpClient.get(this.heartbeatUrl).pipe(
          catchError(() => {
            return of(new FrConnectionState(false))
          }),
          map((response) => {
            if (response instanceof FrConnectionState) {
              return new FrConnectionState(response.hasInternetAccess)
            }
            return new FrConnectionState(true)
          }),
        )
      })
    ));
    
    // return interval(this.heartbeatInterval).pipe(
    //   //skip(1),
    //   switchMap(() => {
    //     return this.httpClient.get(this.heartbeatUrl).pipe(
    //       catchError(() => {
    //         return of(new FrConnectionState(false))
    //       }),
    //       map((response) => {
    //         if (response instanceof FrConnectionState) {
    //           return new FrConnectionState(response.hasInternetAccess)
    //         }
    //         return new FrConnectionState(true)
    //       }),
    //     )
    //   }),
    // );
  }
}

export class FrConnectionState {
  constructor(public readonly hasInternetAccess: boolean) {}
}
